var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_197_312)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_197_312",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 39,
    height: 39
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 0H0V39H39V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_197_312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.64322 23.5683L7.28569 28.6362L2.32393 28.7411C0.84109 25.9908 0 22.8441 0 19.5001C0 16.2666 0.786399 13.2172 2.18035 10.5322H2.18141L6.59877 11.3421L8.53384 15.733C8.12883 16.9137 7.90809 18.1812 7.90809 19.5001C7.90824 20.9316 8.16753 22.303 8.64322 23.5683Z",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6593 15.8569C38.8832 17.0366 39 18.2548 39 19.4998C39 20.8959 38.8532 22.2577 38.5736 23.5713C37.6243 28.0412 35.1439 31.9444 31.708 34.7066L31.7069 34.7055L26.143 34.4216L25.3555 29.5059C27.6355 28.1688 29.4173 26.0763 30.3559 23.5713H19.9287V15.8569H30.508H38.6593Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7068 34.7059L31.7079 34.7069C28.3661 37.393 24.1211 39.0001 19.5 39.0001C12.074 39.0001 5.61757 34.8495 2.32397 28.7413L8.64327 23.5684C10.29 27.9634 14.5297 31.092 19.5 31.092C21.6364 31.092 23.6379 30.5144 25.3553 29.5062L31.7068 34.7059Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9467 4.48926L25.6295 9.66101C23.8521 8.54999 21.751 7.90816 19.5 7.90816C14.417 7.90816 10.0981 11.1802 8.53387 15.7329L2.18136 10.5321H2.1803C5.42567 4.27499 11.9635 0 19.5 0C24.2314 0 28.5696 1.68538 31.9467 4.48926Z",
    fill: "#F14336"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_197_312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.af21de23f4da9fa5159184f4b9580f16.svg";
export { ForwardRef as ReactComponent };